let ctx;

function ac() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

export const isMuted = () => localStorage.getItem("duelo-muted") === "1";
export const setMuted = (m) => localStorage.setItem("duelo-muted", m ? "1" : "0");

function tone(freq, dur, type = "sine", vol = 0.07, when = 0) {
  if (isMuted()) return;
  try {
    const a = ac();
    const o = a.createOscillator();
    const g = a.createGain();
    o.type = type;
    o.frequency.value = freq;
    const t0 = a.currentTime + when;
    g.gain.setValueAtTime(vol, t0);
    g.gain.exponentialRampToValueAtTime(0.001, t0 + dur);
    o.connect(g).connect(a.destination);
    o.start(t0);
    o.stop(t0 + dur + 0.02);
  } catch (_) {}
}

export const sfx = {
  move: () => tone(520, 0.09, "triangle", 0.06),
  ai: () => tone(340, 0.09, "triangle", 0.045),
  win: () => {
    tone(523, 0.12, "sine", 0.07);
    tone(659, 0.12, "sine", 0.07, 0.1);
    tone(784, 0.22, "sine", 0.08, 0.2);
  },
  lose: () => {
    tone(220, 0.18, "sawtooth", 0.04);
    tone(165, 0.26, "sawtooth", 0.04, 0.14);
  },
  draw: () => tone(392, 0.16, "sine", 0.05),
};
